import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"

const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const createPartnerAction = createAsyncThunk(
    'create-partner',
    async (data, { rejectWithValue }) => {
        // return
        try {
            const res = await axios.post(`/admins/api/add/partner`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const createPartnerSlice = createSlice({
    name: 'create-partner',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(createPartnerAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(createPartnerAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(createPartnerAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const createPartnerReducer = createPartnerSlice.reducer